// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__nfjXX","reportBodyText":"style__reportBodyText__wfSkh"};